import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { BibliographicResourceService } from '®shared/bibliographic-resource';

import {
  FetchBibliographicResourceAction,
  FetchBibliographicResourceFailedAction,
  FetchBibliographicResourceSuccessAction,
  ResourceActionTypes,
  UpdateBibliographicResourceAction,
  UpdateBibliographicResourceFailedAction,
  UpdateBibliographicResourceSuccessAction,
} from './resource.actions';

@Injectable()
export class ResourceEffects {
  fetchBibliographicResource$: Observable<
    | FetchBibliographicResourceFailedAction
    | FetchBibliographicResourceSuccessAction
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(ResourceActionTypes.FETCH_RESOURCE),
      mergeMap((action: FetchBibliographicResourceAction) =>
        this.bibliographicResourceService
          .getBibliographicResource(action.payload.resourceId)
          .pipe(
            map(bibliographicResourceData => {
              return new FetchBibliographicResourceSuccessAction({
                resourceId: action.payload.resourceId,
                bibliographicResourceData,
              });
            }),
            catchError(error =>
              of(
                new FetchBibliographicResourceFailedAction({
                  error,
                  resourceId: action.payload.resourceId,
                }),
              ),
            ),
          ),
      ),
    ),
  );

  updateBibliographicResource$: Observable<
    | UpdateBibliographicResourceSuccessAction
    | UpdateBibliographicResourceFailedAction
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(ResourceActionTypes.UPDATE_RESOURCE),
      mergeMap((action: UpdateBibliographicResourceAction) =>
        this.bibliographicResourceService
          .updateResource(action.payload.bibliographicResource)
          .pipe(
            map(
              updatedResource =>
                new UpdateBibliographicResourceSuccessAction({
                  bibliographicResource: updatedResource,
                }),
            ),
            catchError(error =>
              of(new UpdateBibliographicResourceFailedAction({ error })),
            ),
          ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private bibliographicResourceService: BibliographicResourceService,
  ) {}
}
